import { setComponentWidths } from "components/components/ComponentWidthSetUtil";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { Tooltip } from "components/components/tooltip/tooltip";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import i18n from "components/i18n/i18n";
import $ from "jquery";
import {
    InputComponent,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import template from "./file.hbs";
import "./file.scss";

export class FileInput extends InputBaseComponent<FileInputDefinition> implements InputComponent {
    public componentType = "fileInput";
    private visited: boolean = false;
    private valid: boolean = true;
    private validationMessage: string = null;
    public originalData: FileInputData;
    private data: FileInputData;
    private input: HTMLInputElement;
    private trash: any;
    private readOnly: boolean;
    private label: any;

    constructor(schema: FileInputDefinition) {
        super(schema);
        setComponentWidths(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        Tooltip.bindElement(this.view.querySelector(".o-form-component__input-group"));
        return this.view;
    }

    public renderTemplate(): Element {
        let jqueryView = $(template(Object.assign(this.definition, {
            _inputWidth: 1 * this.definition.maxlength + 3,
        })));
        this.view = jqueryView[0];
        this.input = this.view.querySelector("input");
        this.trash = this.view.querySelector(".c-file-input__input__delete");
        this.label = this.view.querySelector(".c-file-input__input__label");
        return this.view;
    }

    private bindEvents(): void {
        this.input.addEventListener("change", () => {
            let reader = new FileReader();
            let v = this.input.files[0];
            if (v == null) {
                this.data = null;
                fireDataChangedEvent(this, this.view, this.getValue());
                return;
            }
            reader.readAsDataURL(v);
            reader.onloadend = () => {
                this.data = {
                    name: v.name,
                    data: reader.result as string,
                };
                fireDataChangedEvent(this, this.view, this.getValue());
            };
        });

        this.label.addEventListener("focus", () => {
            this.visited = true;
        });
        this.label.addEventListener("focusout", () => {
            this.setValidationStatus(this.valid, this.validationMessage);
        });

        // Acción al pulsar el botón de borrar
        this.trash.addEventListener("click", () => {
            if (this.readOnly) {
                return;
            }
            this.setLabelText(null, false);
            this.input.value = "";
            // Establecer data a null
            this.value(null);
            fireDataChangedEvent(this, this.view, this.getValue());
        });

        // Cambia el label del input al hacer un cambio
        this.input.addEventListener("change", () => {
            if (this.getValue() !== undefined || this.getValue() !== null) {
                let v = this.input.value;
                this.setLabelText(v, false);
            }
        });
        this.input.addEventListener("focusout", () => {
            this.setValidationStatus(this.valid, this.validationMessage);
        });
    }

    private setLabelText(v: string, t: boolean) {
        if (v != null) {
            if (!t) {
                v = v.substring(v.lastIndexOf("\\") + 1, v.length);
            } else {
                v = '<i class="fas fa-upload c-file-input__input__label__icon"></i>' + v;
            }

            this.label.innerHTML = v;
        }
    }

    public getValue(): FileInputData {
        return this.data;
    }

    public value(v: string) {
        if (this.originalData == null) {
            this.originalData = {
                name: v,
                data: null,
            };
        }
        if (v == null) {
            this.data = null;
            this.setLabelText(i18n.instance.t("inputs.selectFile"), true);
            this.input.value = "";
        } else {
            this.data = JSON.parse(JSON.stringify(v));
            this.setLabelText(this.data.name, false);
        }
    }

    public setReadOnly(ro: boolean) {
        this.readOnly = ro;
        this.input.disabled = ro;
        if (ro) {
            this.label.classList.add("c-file-input__input__label--disabled")
        } else {
            this.label.classList.remove("c-file-input__input__label--disabled")

        }
    }

    public setRequired(required: boolean) {
        if (required) {
            this.view.querySelector("label").classList.add("is-required");
        } else {
            this.view.querySelector("label").classList.remove("is-required");
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.valid = valid;
        this.validationMessage = message || null;
        let inputGroup = this.view.querySelector(".o-form-component__input-group");
        
        if (valid) {
            this.label.classList.remove("is-pending");
            this.label.classList.remove("has-error");
            inputGroup.removeAttribute("data-tip");
        } else {
            if (this.visited) {
                this.label.classList.add("has-error");
                this.label.classList.remove("is-pending");
            } else {
                this.label.classList.remove("has-error");
                this.label.classList.add("is-pending");
            }
            inputGroup.setAttribute("data-tip", message);
        }
    }
}

export interface FileInputDefinition extends LabeledComponentDefinition, ValueComponentDefinition {
    inputWidth?: number;
    emptyWidth?: number;
    maxlength?: number;
}
export interface FileInputData {
    name: string;
    data: string;
}
